import React from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {types} from 'main/tools';

const Hours = observer(({model}) => {
  if (model._type === types.TIME_OFF.ABSENCE) {
    return <div className='right-align pr1'>{parseFloat(model.amount)}</div>;
  }

  return (
    <div className='right-align pr1'>
      <div className='Tooltip'>
        <div>{model.hours}</div>
        {model.unpaidBreakMinutes > 0 && <div className='h6 jumbo'>
          <FormattedMessage id='time_tracking.timesheet.UNPAID_BREAK_HOURS' values={{hours: model.unpaidBreakHours}}/>
          <span className='tooltiptext dateTooltip'>
            <FormattedMessage id='time_tracking.timesheet.HOURS_CALCULATION' values={{worked: model.hours, unpaid: model.unpaidBreakHours}}/>
          </span>
        </div>}
      </div>
    </div>
  );
});

export default Hours;
